import React, { Dispatch, SetStateAction, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
// import { ContinuosReportingType } from "../ContinuosReporting";
// import { createStatementByProjectId } from "lib/api_ts/continuosReportingApi";
import { useLocation } from 'react-router-dom-v5-compat';
import StatusBar from 'components/StatusBar';
import { createStatementByProjectId } from 'lib/api_ts/continuosReportingApi';

interface ContinuosReportingCreateModalProps {
	isModalOpen: boolean;
	setIsModalOpen: Dispatch<SetStateAction<boolean>>;
	fetchData: () => void;
}

const ContinuosReportingCreateModal: React.FC<ContinuosReportingCreateModalProps> = ({ isModalOpen, setIsModalOpen, fetchData }) => {
	const { pathname } = useLocation();
	const projectId = pathname.split('/')[2];

	const blankReportToCreate = {
		note: '',
	};
	const [reportToCreate, setReportToCreate] =
		// useState<Partial<ContinuosReportingType>>(blankReportToCreate);
		useState<{ note: string }>(blankReportToCreate);
	const resetReportToCreate = () => {
		setReportToCreate(blankReportToCreate);
	};

	const blankStatusBar = {
		status: undefined,
		message: '',
		timeout: undefined,
	};

	const [statusBar, setStatusBar] = useState(blankStatusBar);
	const resetStatusBar = () => {
		setStatusBar(blankStatusBar);
	};

	const handleCreate = async () => {
		setStatusBar({
			status: 'elaborating',
			message: 'Creazione Continuos Reporting in corso',
			timeout: false,
		});
		try {
			await createStatementByProjectId(projectId, {
				statementTypeCode: 'CR',
				note: reportToCreate.note,
			});
			setStatusBar({
				status: 'success',
				message: 'Continuos Reporting creato con successo',
				timeout: true,
			});
			setTimeout(() => {
				setIsModalOpen(false);
				resetStatusBar();
				resetReportToCreate();
				fetchData();
			}, 2000);
			console.log('created', reportToCreate);
		} catch (error) {
			console.error('error', error);
			setStatusBar({
				status: 'error',
				message: 'Errore durante la creazione del Continuos Reporting',
				timeout: true,
			});
			setTimeout(() => {
				resetStatusBar();
			}, 2000);
		}
	};
	return (
		<Modal
			size="lg"
			show={isModalOpen}
			onHide={() => {
				setIsModalOpen(false);
				resetReportToCreate();
				resetStatusBar();
			}}
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title>Nuovo Continuos Reporting</Modal.Title>
			</Modal.Header>
			<Form>
				<Modal.Body>
					<Row className="mb-3" style={{ marginTop: '2rem' }}>
						<Form.Group as={Col} md={6}>
							<Form.Label className="mb-3">Note</Form.Label>
							<Form.Control
								value={reportToCreate.note || ''}
								onChange={(event) => {
									setReportToCreate((prevReportToCreate) => ({
										...prevReportToCreate,
										note: event.target.value,
									}));
								}}
							/>
						</Form.Group>
						{/* <Form.Group as={Col} md={6}>
              <Form.Label className="mb-3">Data Prevista fine</Form.Label>
              <Form.Control
                type="date"
                value={reportToCreate.endDate || ""}
                onChange={(event) => {
                  setReportToCreate((prevReportToCreate) => ({
                    ...prevReportToCreate,
                    endDate: event.target.value,
                  }));
                }}
              />
            </Form.Group> */}
					</Row>
					{statusBar.status ? (
						<StatusBar status={statusBar.status} message={statusBar.message} timeout={statusBar.timeout}>
							<></>
						</StatusBar>
					) : null}
				</Modal.Body>
				<Modal.Footer>
					<Button
						onClick={(event) => {
							event.preventDefault();
							handleCreate();
						}}
					>
						Crea
					</Button>
				</Modal.Footer>
			</Form>
		</Modal>
	);
};

export default ContinuosReportingCreateModal;
